/* Merchant Metrics Service */
import Request from './request';

export default class MerchantMetricsService {
  /**
   * Fetch merchant metrics, optionally filtered by a date
   * @param at ISO datetime string, e.g., '2025-11-01T00:00:00-05:00'
   */
  static async getMetrics(at) {
    return new Promise((resolve) => {
      // Build query params if `at` is provided
      const query = at ? { at } : undefined;

      Request.send({
        method: 'GET',
        path: 'admin/metrics/merchants',
        query, // pass query params to backend
      })
        .then((result = {}) => {
          console.log('Merchant metrics response:', result);

          // Normalize nested response
          if (result.success && result.data) {
            const metricsData = Array.isArray(result.data.data)
              ? result.data.data
              : result.data;

            return resolve({
              success: true,
              data: metricsData,
              message: result.data.message || result.message || 'Success',
            });
          }

          return resolve(result);
        })
        .catch((error) => {
          console.error('Merchant metrics error:', error);
          return resolve({
            success: false,
            errors: [
              { message: error.message || 'Failed to fetch merchant metrics' },
            ],
          });
        });
    });
  }
}
